var generateStyle = function generateStyle(componentTheme) {
  return {
    instructionsShowWrapper: {
      position: 'relative',
      width: '100%',
      minHeight: '4rem',
      boxSizing: 'border-box',
      padding: componentTheme.instructionsShowWrapperPadding,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    instructionsShowText: {
      label: 'instructionsShowText',
      whiteSpace: 'normal',
      overflow: 'hidden',
      fontSize: componentTheme.instructionsShowTextFontSize,
      '& p': {
        margin: 16,
        '&:first-of-type': {
          marginTop: 0
        },
        '&:last-child': {
          marginBottom: 0
        }
      }
    }
  };
};
export default generateStyle;